import { render, staticRenderFns } from "./MessageClinicPattern.vue?vue&type=template&id=3b1d11f1&scoped=true&"
import script from "./MessageClinicPattern.vue?vue&type=script&lang=ts&"
export * from "./MessageClinicPattern.vue?vue&type=script&lang=ts&"
import style0 from "./MessageClinicPattern.vue?vue&type=style&index=0&id=3b1d11f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d11f1",
  null
  
)

export default component.exports